// @flow
import React from 'react'
import I18n from 'i18n-react'
import Modal from 'reactstrap/lib/Modal'
import ModalHeader from 'reactstrap/lib/ModalHeader'
import ModalBody from 'reactstrap/lib/ModalBody'
import moment from '../Moment'

type ConfirmModalProps = {
  callDate: string,
  callTime: string,
  isOpen: boolean,
  toggleModal: () => void,
}

export default class ConfirmModal extends React.PureComponent<ConfirmModalProps> {
  static defaultProps = {
    callTime: '',
  }

  render() {
    const { callTime, isOpen, toggleModal, callDate } = this.props
    if (!isOpen) {
      return null
    }
    const actualDate = moment().format("DD.MM.YYYY")
    const selectDate = moment(callDate, 'YYYY-MM-DD').format("DD.MM.YYYY")
    let timeText = ""
    if (actualDate !== selectDate) {
      timeText += selectDate + " " + I18n.translate("cl.general.confirmTimeText") + " "
      timeText += callTime;
    } else {
      timeText = callTime.toLowerCase()
    }

    return (
      <Modal isOpen toggle={toggleModal}>
        <ModalHeader>
          <button className="close" onClick={toggleModal} type="button">
            <i className="pfp pfp-close" />
          </button>
        </ModalHeader>
        <ModalBody>
          <div>
            <div className="col-xs-12 main-form">
              <div className="d-none d-sm-block">
                <div className="form-group d-flex flex-row flex-wrap flex-sm-row align-items-center">
                  {I18n.translate('cl.general.confirmText')}&nbsp;
                  {timeText}
                </div>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
    )
  }
}
